import {useState ,Link, useParams } from '../../InBuildImports';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ViewResume from './ViewResume';
import CheckResume from './CheckResume';
import { ListItem } from '@mui/material';
import '../css/TADashBoard.css';
import {Navigation} from '../../CommonImports';



function TalendDashBoard() {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };
  const { paramValue } = useParams();
  const routes = [ 
    { path: Navigation.NAVIGATE_URL_VIEW_RESUME, element: <ViewResume /> }, 
    { path: Navigation.NAVIGATE_URL_CHECK_RESUME, element: <CheckResume /> }, 
  ];

  return (
    <BrowserRouter>
      <div style={{width:"100%"}}>
      
       <ListItem  className="GRview" style={{width:"33%"}}

          component={Link}
          to={"/ViewResume"}
        ><h1 >View Talent DashBoard</h1>
          
        </ListItem>
        <div className="viewresumeroutediv" >   
          <Routes>
            {routes.map((route, index) => (
              <Route key={index} path={route.path} element={route.element} />
            ))}          
          </Routes>
        </div>
      </div>


     {/* <Footer /> */}
    </BrowserRouter>
  );
}

export default TalendDashBoard;

